export const portfolioData = [
  {
    id: 1,
    name: "ShowCase",
    description:
      "Create a dynamic marketplace where users can dynamically pick up items from the shelves and drop them into the shopping cart.",
    img: "https://github.com/CarlosRQuinteroM/Proyecto-2-WebPersonal/blob/master/img/ShowCase.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/ShowCase",
  },
  {
    id: 2,
    name: "Video Consola ",
    description:
      "Draw with CSS and HTML the front image of our favorite video game console.",
    img: "https://github.com/CarlosRQuinteroM/Proyecto-2-WebPersonal/blob/master/img/consola.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/Proyecto-1VideoConsola",
  },
  {
    id: 3,
    name: "Veterinary appointments",
    description:
      "App made with react for creating appointments in a veterinary clinic.",
    img: "https://github.com/CarlosRQuinteroM/Proyecto-2-WebPersonal/blob/master/img/Veterinaria.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/Citas",
  },
  {
    id: 4,
    name: "Weekly budget",
    description:
      "App made with react, helps to control the weekly expenses of the users.",
    img: "https://github.com/CarlosRQuinteroM/Proyecto-2-WebPersonal/blob/master/img/presupuesto.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/Presupuesto-",
  },
  {
    id: 5,
    name: "The Fake Fork",
    description:
      "App made to be able to make reservations at different restaurants in the city of Valencia. in collaboration with @juanfegallego ",
    img: "https://github.com/juanfegallego/proyecto_6_React/raw/develop/src/components/img/home2.png",
    url: "https://github.com/juanfegallego/proyecto_6_React/tree/develop",
  },
  {
    id: 6,
    name: "Bollywood",
    description:
      "Online movie booking app. using MoviDatabase as sources of information for the movies",
    img: "https://github.com/CarlosRQuinteroM/BOLLYWOOD/blob/develop/src/img/bollywood.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/BOLLYWOOD",
  },
  {
    id: 7,
    name: "Recetas",
    description:
      " App made for food planning of users. Preparing automated recipes depending on what is available in the pantry.",
    img: "https://github.com/CarlosRQuinteroM/Proyecto_Final_Recetas/blob/develop/src/Img/Screenshot%202021-08-10%20130200.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/Proyecto_Final_Recetas",
  },
  {
    id: 8,
    name: "DiscoverTheUniverse",
    description:
      " Users of EARTHFLY are able to choose a destination within our solar system and book a ticket one a launch of their choosing.",
    img: "https://github.com/CarlosRQuinteroM/DiscoverTheUniverse/blob/master/public/images/Screenshot%202021-11-18%20132436.png?raw=true",
    url: "https://github.com/CarlosRQuinteroM/DiscoverTheUniverse",
  },
];
export default portfolioData;
